import { Divider } from '@packages/shared/src/ui/Divider/Divider';
import { Skeleton } from '@packages/shared/src/ui/Skeleton/Skeleton';

export const MultiStepFormSkeleton = () => (
  <div className="w-full min-w-lg">
    <div className="flex flex-row gap-2 p-2">
      <Skeleton className="h-[88px] w-[65px]" />
      <div className="w-full">
        <Skeleton className="mb-2 h-4 w-full" />
        <Skeleton className="mb-1 h-2 w-1/3" />
        <Skeleton className="h-1 w-1/4" />
      </div>
    </div>
    <Divider />
    <div className="flex flex-col gap-2 p-2">
      {/* RatingInput */}
      <Skeleton className="h-[88px] w-1/3 self-center" />
      {/* Recommended */}
      <div>
        <Skeleton className="mb-1 h-1 w-1/2" />
        <div className="flex flex-row items-center gap-4">
          <Skeleton className="size-2" />
          <Skeleton className="h-1 w-3" />
          <Skeleton className="size-2" />
          <Skeleton className="h-1 w-3" />
        </div>
      </div>
      {/* TitleInput */}
      <div>
        <Skeleton className="mb-1 h-1 w-1/4" />
        <Skeleton className="h-4 w-full" />
      </div>
      {/* DescriptionInput */}
      <div>
        <Skeleton className="mb-1 h-1 w-1/4" />
        <Skeleton className="h-[88px] w-full" />
      </div>
      {/* NameInput */}
      <div>
        <Skeleton className="mb-1 h-1 w-1/4" />
        <Skeleton className="h-4 w-full" />
      </div>
      {/* Terms */}
      <Skeleton className="h-2 w-full" />
      {/* MandatoryHint */}
      <Skeleton className="h-2 w-full" />
      {/* Buttons */}
      <Skeleton className="h-4 w-1/3 self-end" />
    </div>
  </div>
);
